<template>
  <div>
    <b-modal id="details" header-bg-variant="warning" hide-footer body-bg-variant="dark">
      <template class="bg-success" #modal-title>
        Order details
      </template>
      <b-table :items="orderDetails" :fields="['name', 'sku', 'quantity']"></b-table>
      <b-button class="mt-3 px-3 bg-light text-dark float-right" @click="clearDetails">Close</b-button>
    </b-modal>
    <div class="row">
      <div class="w-100 text-center mt-3">
        <h3>Parts Sold By AirSuspension</h3>
      </div>
      <div class="w-100 mt-3 mb-3 p-3 border-bottom border-danger">
        <div class="col-md-3 col-sm-4 d-md-inline-block">
          <span>Start Date:</span>
          <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="fromDate" class="text-dark"></datepicker>
        </div>
        <div class="col-md-3 col-sm-4 d-md-inline-block">
          <span>End Date:</span>
          <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="toDate" class="text-dark"></datepicker>
        </div>
        <div class="col-md-6 col-sm-4 d-md-inline-block mt-3">
          <button @click="fetchOrders" :class="!fromDate || !toDate ? 'btn-outline-danger disabled' : 'btn-success'" class="btn px-5">
            SEARCH <b-icon-search shift-h="10"></b-icon-search>
          </button>
        </div>
      </div>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <area-chart
      :colors="['#dc3545']"
      :dataset="{borderWidth: 4}"
      :messages="{empty: 'Select date range to generate stats'}"
      :data="chartData"></area-chart>

    <div v-if="Object.keys(data).length">
      <div class="row mt-3 overflow-hidden">
        <div class="col-12">
          <table class="table">
            <thead>
            <tr class="text-right">
              <th scope="col" class="text-left">#</th>
              <th scope="col" class="text-left">Date</th>
              <th scope="col" class="d-none d-sm-table-cell">Status</th>
              <th class="d-none d-sm-table-cell" scope="col">Created via</th>
              <th scope="col">Total</th>
              <th class="d-none d-sm-table-cell" scope="col">Tax</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(val, key) of data" v-bind:key="key" @click="checkDetails(val.lineItems)" class="text-right pointer">
              <th scope="row" class="text-left">{{key + 1}}</th>
              <td class="text-left">{{moment(val.dateCreated.time).format('DD.MM.yyyy HH:mm:ss')}}</td>
              <td class="d-none d-sm-table-cell">{{val.status}}</td>
              <td class="d-none d-sm-table-cell">{{val.createdVia}}</td>
              <td class="d-sm-table-cell">{{Math.round(val.total).toLocaleString('no')}}kr</td>
              <td class="d-none d-sm-table-cell">{{Math.round(val.totalTax).toLocaleString('no')}}kr</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row overflow-hidden d-flex">
        <div class="col-md-4 col-sm-6 ml-auto">
          <table class="table font-weight-bolder float-right">
            <tr class="bg-primary">
              <td class="text-right">TOTAL:</td>
              <td class="text-right">{{Math.round(this.total).toLocaleString('no')}} KR</td>
            </tr>
            <tr class="bg-success">
              <td class="text-right">TOTAL COMPLETED:</td>
              <td class="text-right">{{Math.round(this.totalCompleted).toLocaleString('no')}} KR</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';

import fixed from '../../fixed';

export default {
  name: 'AirStats',
  components: {
    Datepicker,
  },
  data: () => ({
    loading: false,
    data: {},
    fromDate: null,
    toDate: null,
    total: 0,
    totalCompleted: 0,
    orderDetails: [],

    moment,
  }),
  async mounted() {
    this.toDate = new Date();
    this.fromDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), 1);
    await this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      if (!this.fromDate || !this.toDate) return;
      this.loading = true;

      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/admin/airsuspension-stats?from=${moment(this.fromDate).format('yyyy-MM-DD')}&to=${moment(this.toDate).format('yyyy-MM-DD')}`,
          { withCredentials: true },
        );

        this.totalCompleted = 0;
        this.total = 0;
        this.data = data || [];
      } catch (error) {
        console.error(error); // eslint-disable-line
      }
      this.loading = false;
    },
    checkDetails(order) {
      this.orderDetails = order;
      this.$bvModal.show('details');
    },
    clearDetails() {
      this.orderDetails = [];
      this.$bvModal.hide('details');
    },
  },
  computed: {
    chartData() {
      const dataSet = {};
      Object.entries(this.data).forEach(([_, value]) => { // eslint-disable-line
        this.total += value.total;
        this.totalCompleted += value.status === 'completed' ? value.total : 0;
        dataSet[value.dateCreated.time] = value.total;
      });
      return dataSet;
    },
  },
};
</script>

<style scoped>

</style>
